import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-16 px-4 bg-black text-white border-y-8 border-red-600" data-id="element-150">
      <div className="max-w-3xl mx-auto" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-8 text-lg md:text-xl" data-id="element-152">
          <div className="text-center mb-12" data-id="element-153">
            <h2 className="text-3xl md:text-4xl font-black text-yellow-400 mb-6" data-id="element-154">
              Si sos mamá o papá, necesito que leas esto con el corazón abierto
            </h2>
            <p className="font-bold text-2xl leading-relaxed" data-id="element-155">
              ¿Cuántas veces quisiste pasar un momento especial con tus hijos…
              <br data-id="element-156" />
              <span className="text-red-400" data-id="element-157">
                pero el día se terminó sin que pasara nada memorable?
              </span>
            </p>
          </div>

          <div className="space-y-4 text-gray-300 max-w-2xl mx-auto" data-id="element-158">
            <p data-id="element-159">No es porque no los ames. Los amás con todo.</p>
            <p data-id="element-160">No es porque no quieras estar. Querés estar más que nada.</p>
            <p className="font-bold text-white" data-id="element-161">
              Pero la rutina, el trabajo, el cansancio y las pantallas se comen
              cada minuto del día.
            </p>
            <p data-id="element-162">Y cuando querés darte cuenta…</p>
            <p className="font-bold text-red-400 text-2xl" data-id="element-163">
              otro día pasó sin conexión real.
            </p>
          </div>

          <div className="bg-gray-900 p-8 rounded-xl border border-gray-700 mt-12 shadow-2xl" data-id="element-164">
            <h3 className="text-2xl font-black text-white mb-6 border-b border-gray-700 pb-4" data-id="element-165">
              La verdad que duele pero nadie dice en voz alta
            </h3>
            <div className="space-y-4 text-gray-300" data-id="element-166">
              <p data-id="element-167">
                Muchos padres están en la misma habitación que sus hijos…{' '}
                <span className="text-yellow-400 font-bold" data-id="element-168">
                  pero no hay conexión real entre ellos.
                </span>
              </p>
              <p data-id="element-169">Cada uno mirando su pantalla. En silencio.</p>
              <p data-id="element-170">
                Querés proponer algo distinto, pero no se te ocurre qué. Y el
                momento pasa.
              </p>
              <p data-id="element-171">Los días se repiten.</p>
              <p data-id="element-172">Los hijos crecen sin esperar.</p>
              <p className="italic text-xl text-white font-medium border-l-4 border-red-500 pl-4 my-6" data-id="element-173">
                "Sé que podría estar creando mejores momentos con ellos… si
                tuviera algo listo para usar."
              </p>
            </div>
          </div>

          <div className="text-center mt-12 space-y-4" data-id="element-174">
            <p className="text-2xl font-bold text-white" data-id="element-175">
              No es falta de amor. Nunca lo fue.
            </p>
            <p className="text-2xl font-bold text-yellow-400" data-id="element-176">
              Es falta de un plan simple para conectar.
            </p>

            <div className="text-left max-w-xl mx-auto mt-8 space-y-4 text-gray-300" data-id="element-177">
              <p data-id="element-178">
                Miles de padres quieren crear recuerdos con sus hijos. Pero:
              </p>
              <ul className="space-y-2 font-medium text-white" data-id="element-179">
                <li className="flex items-center gap-2" data-id="element-180">
                  ❌ no saben qué actividades proponer
                </li>
                <li className="flex items-center gap-2" data-id="element-181">
                  ❌ no tienen tiempo ni energía para planificar
                </li>
                <li className="flex items-center gap-2" data-id="element-182">
                  ❌ terminan dejándolo para "otro día" que nunca llega
                </li>
              </ul>
              <p className="text-xl font-bold text-red-400 mt-6 text-center" data-id="element-183">
                Y mientras tanto, la infancia sigue avanzando.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}